<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.domains', 2),
                        href: meta.links.index,
                    },
                    {
                        name: category.name,
                        href: meta.links.show,
                    },
                ]"
            />
        </template>

        <div>
            {{ subject.name }}
        </div>

        <div>
            {{ $tc('messages.content_blocks', 2) }}
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="table-fixed min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="w-10 max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                            </tr>
                        </thead>

                        <draggable
                            tag="tbody"
                            v-model="form.content_blocks"
                            group="content_blocks"
                            handle=".handle"
                            item-key="id"
                        >
                            <template #item="{ element: block, index }">
                                <tr :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-100'" :key="index">
                                    <td class="truncate px-6 py-4 text-sm leading-5 text-gray-900">
                                        <div class="flex space-x-2 items-center">
                                            <IconGripVertical
                                                class="handle inline-block h-4 w-4 text-gray-600 cursor-move"
                                            />
                                            <span class="ml-1 tabular-nums">{{ index + 1 }}.</span>
                                            <span class="ml-1">{{ block.name }}</span>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>
        <form action="" @submit.prevent="reorder()">
            <div class="flex justify-end mt-5" :class="form.isDirty ? 'visible' : 'invisible'">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import { IconGripVertical } from '@tabler/icons-vue';
import draggable from 'vuedraggable';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        IconGripVertical,
        draggable,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['category', 'subject', 'blocks', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                content_blocks: this.blocks,
            }),
        };
    },
    methods: {
        reorder() {
            const newOrder = this.form.content_blocks.map((cb, i) => {
                return {
                    id: cb.id,
                    order: i,
                };
            });
            this.$inertia.patch(
                this.meta.links.update,
                { content_blocks: newOrder },
                {
                    preserveScroll: true,
                    onSuccess: function onSuccess() {
                        this.form.content_blocks = this.blocks;
                        this.form.reset();
                    },
                },
            );
        },
    },
};
</script>
